import { render, staticRenderFns } from "./ManagerPage.vue?vue&type=template&id=8616c684&scoped=true&"
import script from "./ManagerPage.vue?vue&type=script&lang=js&"
export * from "./ManagerPage.vue?vue&type=script&lang=js&"
import style0 from "./ManagerPage.vue?vue&type=style&index=0&id=8616c684&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8616c684",
  null
  
)

export default component.exports